<template>
  <div v-if="weekSelectedNumber !== null" class="programmes-container">
    <div class="programmes-header">
      <h2>My Programmes</h2>
      <span class="week-badge">Week {{ weekSelectedNumber }} &middot; {{ selectedWeekMonSunday }}</span>
    </div>

    <div class="programmes-grid">
      <a href="javascript:;" v-for="card in programmeCards" :key="card.type"
        @click="openTrainingPlanPage(userData.id, 'User', card.type)" class="programme-card" :class="card.colorClass">
        <div class="card-accent"></div>
        <div class="card-body">
          <div class="card-icon" v-html="card.icon"></div>
          <div class="card-info">
            <h3>{{ card.label }}</h3>
            <p class="card-description">{{ card.description }}</p>
          </div>
          <div class="card-arrow">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
        </div>
      </a>
    </div>
  </div>
  <div v-else>
    <div class="empty-state">
      <img src="../img/emptyStateIllustration.svg" />
      <p>No Programmes. Please select a date above to view your programmes.</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import {
  CHECK_PROFILE_HAS_DATA,
  USER_POPULATE,
  POPULATE_SELECTED_USER_DATA,
} from "@/store/actions/user.js";
import { Users } from "@/services/user-service.js";

export default {
  name: "trainingPlanLinks",
  data() {
    return {
      loadingStuff: false,
      weekSelectedNumber: "",
      selectedWeekMonSunday: "",
      userData: "",
      programmeCards: [
        {
          type: "Training Plan",
          label: "Training Plan",
          description: "View your weekly training sessions and exercises",
          colorClass: "card-blue",
          icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>',
        },
        {
          type: "Mental training",
          label: "Mental Training",
          description: "Mental preparation and mindset development",
          colorClass: "card-purple",
          icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7z"></path><line x1="9" y1="21" x2="15" y2="21"></line></svg>',
        },
        {
          type: "Nutrition",
          label: "Nutrition",
          description: "Meal plans and dietary guidance",
          colorClass: "card-green",
          icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line></svg>',
        },
        {
          type: "Recovery",
          label: "Recovery",
          description: "Recovery protocols and rest day activities",
          colorClass: "card-orange",
          icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>',
        },
      ],
    };
  },
  props: {
    selectedUserData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["getProfile"]),
  },
  async created() {
    this.weekSelectedNumber = moment().isoWeek();
    const response = await this.$store.dispatch(CHECK_PROFILE_HAS_DATA);
    this.selectedWeekMonSunday = localStorage.getItem(
      "mondaySunDates",
      this.selectedWeekMonSunday,
    );
    const clientId = JSON.parse(localStorage.getItem("the_w_selectedClientId"));
    response === true ? this.setUser() : this.getUserById(clientId);
  },
  methods: {
    openTrainingPlanPage(userId, userType, planType) {
      if (userType === "User") {
        this.$store.dispatch(POPULATE_SELECTED_USER_DATA, userId);
        this.$router.push({
          name: "trainingPlans",
          params: { trainingPlanUserId: 0, trainingPlanType: planType },
        });
      } else {
        this.$router.push({
          name: "trainingPlans",
          params: { trainingPlanUserId: userId, trainingPlanType: planType },
        });
      }
    },
    setUser() {
      if (this.getProfile !== null) {
        this.userData = this.getProfile;
      }
    },
    async getUserById(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.userData = responce.data[0];
        const userData = responce.data[0];
        this.$store.dispatch(USER_POPULATE, { userData });
      }
    },
  },
};
</script>

<style scoped>
.programmes-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 1.5rem;
}

.programmes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.programmes-header h2 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}

.week-badge {
  background: #f0f0f5;
  color: #555;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0.35rem 0.85rem;
  border-radius: 20px;
}

.programmes-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.programme-card {
  display: flex;
  align-items: stretch;
  background: #fff;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #eee;
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.programme-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: inherit;
}

.card-accent {
  width: 5px;
  flex-shrink: 0;
}

.card-blue .card-accent {
  background: #4a90d9;
}

.card-purple .card-accent {
  background: #7c5cbf;
}

.card-green .card-accent {
  background: #27ae60;
}

.card-orange .card-accent {
  background: #e67e22;
}

.card-body {
  display: flex;
  align-items: center;
  padding: 1.1rem 1.25rem;
  flex: 1;
  gap: 1rem;
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-blue .card-icon {
  background: #eaf2fb;
  color: #4a90d9;
}

.card-purple .card-icon {
  background: #f0ebf8;
  color: #7c5cbf;
}

.card-green .card-icon {
  background: #e8f8ef;
  color: #27ae60;
}

.card-orange .card-icon {
  background: #fdf0e3;
  color: #e67e22;
}

.card-info {
  flex: 1;
  min-width: 0;
}

.card-info h3 {
  font-size: 1.05rem;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 0.2rem 0;
}

.card-description {
  font-size: 0.85rem;
  color: #888;
  margin: 0;
}

.card-arrow {
  color: #ccc;
  flex-shrink: 0;
  transition: color 0.15s ease;
}

.programme-card:hover .card-arrow {
  color: #888;
}

.empty-state {
  text-align: center;
  padding: 3rem 1.5rem;
}

.empty-state img {
  max-width: 180px;
  margin-bottom: 1rem;
  opacity: 0.7;
}

.empty-state p {
  color: #888;
  font-size: 0.95rem;
}

@media (max-width: 480px) {
  .programmes-container {
    padding: 1rem;
  }

  .programmes-header h2 {
    font-size: 1.2rem;
  }

  .card-body {
    padding: 0.9rem 1rem;
  }

  .card-description {
    display: none;
  }
}
</style>
